import axios from "axios";

export default {
    namespaced: true,
    state: {
        serviceActive: true,
    },
    mutations: {
        SET_SERVICE_STATUS(state, status) {
            state.serviceActive = status;
        }
    },
    actions: {
        async fetchServiceStatus({ commit }) {
            try {
                const response = await axios.get('https://apitomolab.wost.pe/api/service-status');
                commit('SET_SERVICE_STATUS', response.data.active);
            } catch (error) {
                console.error('Error fetching service status:', error);
            }
        }
    }
}
